module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/angle-double-left-f5eaadbf14ad56d81b732c69bec4618b.svg";